import wx from 'weixin-js-sdk'
import * as services from '../routes/projects/services';
export function FormatTime(date, fmt) {
    let mdate = new Date(date);
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (mdate.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'Y+': mdate.getFullYear(),
        'M+': mdate.getMonth() + 1,
        'd+': mdate.getDate(),
        'h+': mdate.getHours(),
        'm+': mdate.getMinutes(),
        's+': mdate.getSeconds()
    };
    // 遍历这个对象
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
        }
    }
    return fmt;
}
export function FormatTimestr(date, fmt) {
    let sdate = '';
    if (!!date) {
        let o = {
            'Y+': date.substring(0, 4),
            'M+': date.substring(4, 7),
            'd+': date.substring(7, 10),
            'h+': date.substring(10, 13),
            'm+': date.substring(13, 17),
            's+': date.substring(17, 21)
        };
        // 遍历这个对象
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + '';
                sdate += str;
            }
        }
    }
    return sdate;
}
//判断是否是网址
export function IsWebsite(str) {
    var reg = /^(https|http|ftp|rtsp|mms):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
    return reg.test(str);
}
//判断是否包含http或者https
export function IsHttp(url) { 
    let burl='';
    if (url.substr(0, 7).toLowerCase() === "http://" || url.substr(0, 8).toLowerCase() === "https://") {
        burl = url;
    } else {
        burl = "http://" + url;
    }
    return burl;
}

    export function GetSubstring(str, frontLen, endLen) {
        let len = str.length - frontLen - endLen;
        var xing = '';
        for (var i = 0; i < len; i++) {
            xing += '*';
        }
        return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    }
    export function getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null)
            return unescape(r[2]);
        return null;
    }

    export function wxshare(url, title, desc, imgurl) {
        var from = getQueryString('from');
        var appinstall = getQueryString('appinstall');
        var sec = getQueryString('sec');
        var timekey = getQueryString('timekey');
        if (from || appinstall || sec || timekey) {
            window.location.href = url;
        }
        //获取微信信息
        services.GetSignature(url).then(data => {
            if (!!data) {
                if (data.status === 0) {
                    let wxdata = data.result;
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: wxdata.appId, // 必填，公众号的唯一标识
                        timestamp: wxdata.timestamp, // 必填，生成签名的时间戳
                        nonceStr: wxdata.nonceStr, // 必填，生成签名的随机串
                        signature: wxdata.signature,// 必填，签名，见附录1
                        jsApiList: [
                            'onMenuShareAppMessage',
                            'onMenuShareTimeline'
                        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    })
                    wx.ready(() => {
                        //分享给朋友                    
                        wx.onMenuShareAppMessage({
                            title: title, // 分享标题
                            desc: desc, // 分享描述
                            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: imgurl, // 分享图标
                            type: 'link', // 分享类型,music、video或link，不填默认为link
                            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                            success: function () {
                                // 用户确认分享后执行的回调函数
                             
                            },
                            cancel: function () {
                                // 用户取消分享后执行的回调函数
                              
                            }
                        })
                        //分享到朋友圈
                        wx.onMenuShareTimeline({
                            title: title, // 分享标题
                            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: imgurl, // 分享图标
                            success: function () {
                                // 用户确认分享后执行的回调函数
                             
                            },
                            cancel: function () {
                                // 用户取消分享后执行的回调函数
                              
                            }
                        })
                    })
                }
            }
        });
    }